import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { SharesItemFragment } from 'api';
import { PaddedPaper, PostImage } from 'components';
import { getRandomQuote } from 'helpers';
import * as Links from 'Links';

import { Account, ShareCopy, SharePerformance } from 'features/activity/components';
import { getAuthor, getTitle } from 'features/content/helpers';

interface Props {
  shareItem: SharesItemFragment;
}

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8),
    backgroundColor: theme.palette.grey[100],
  },
  title: theme.mixins.clamp(2),
  button: {
    borderRadius: theme.shape.borderRadius * 4,
  },
}));

const TimelineActivity: FC<Props> = ({ shareItem }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [quote] = useState(getRandomQuote());

  if (!shareItem) {
    return (
      <PaddedPaper padding="24px 48px" className={classes.root}>
        <Typography align="center" color="textSecondary" variant="h5">
          <em>{quote}</em>
        </Typography>
      </PaddedPaper>
    );
  }

  const { content } = shareItem;
  const title = getTitle(content);
  const author = getAuthor(content);

  return (
    <PaddedPaper elevation={0} padding="24px 48px" className={classes.root}>
      <Typography align="center" color="textSecondary" variant="h6">
        {t('components:yourPastShares')}
      </Typography>
      <Box marginTop={3} marginBottom={3}>
        <Grid container alignItems="center">
          <Grid item xs={12} md={4}>
            <Grid container alignItems="center" justify="center">
              <Grid item>
                <Account shareItem={shareItem} />
                <ShareCopy item={shareItem} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4}>
            <Grid container wrap="nowrap" spacing={2} justify="center">
              <Grid item>
                <PostImage rounded size={60} content={content} />
              </Grid>
              <Grid item>
                <Typography variant="body2" className={classes.title} color="textPrimary">
                  {title}
                </Typography>
                <Typography>{author}</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4}>
            <Grid container spacing={2} alignItems="center" justify="center">
              <SharePerformance shareItem={shareItem} />
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Box textAlign="center">
        <Button component={Links.Activity} variant="contained" className={classes.button}>
          {t('components:seeAllActivity')}
        </Button>
      </Box>
    </PaddedPaper>
  );
};

export default TimelineActivity;
